import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
    const navigate = useNavigate();
    const [loadingRole, setLoadingRole] = useState(null);

    const handleRoleSelection = async (role, path) => {
        setLoadingRole(role);
        
        // Add a small delay for better UX
        await new Promise(resolve => setTimeout(resolve, 500));
        
        navigate(path);
        setLoadingRole(null);
    };

    const roles = [
        { 
            name: 'Admin', 
            path: '/admin', 
            role: 'admin',
            description: 'System Administration'
        },
        {
            name: 'UAV Operator',
            path: '/uav-operator',
            role: 'uav-operator',
            description: 'Drone Operations'
        },
        { 
            name: 'Deminer', 
            path: '/deminer', 
            role: 'deminer',
            description: 'Field Operations'
        },
        { 
            name: 'Observer', 
            path: '/observer', 
            role: 'observer',
            description: 'Monitoring & Analysis'
        }
    ];

    return (
        <div className="login-container">
            <div className="login-content">
                <h1>Select Your Role</h1>
                <div className="role-selection">
                    {roles.map(({ name, path, role, description }) => (
                        <button
                            key={role}
                            data-role={role}
                            className={loadingRole === role ? 'loading' : ''}
                            onClick={() => handleRoleSelection(role, path)}
                            disabled={loadingRole !== null}
                            aria-label={`Login as ${name} - ${description}`}
                        >
                            {loadingRole === role ? '' : name}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LoginPage;